import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';

import {ApiModule} from '../api/api.module';
import {EmployeesSharedModule} from '../employees/employees-shared.module';
import {UiModule} from '../ui/ui.module';

import {ClaimFormComponent} from './claim-form.component';

@NgModule({
  imports: [
    ApiModule,
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    EmployeesSharedModule,
    UiModule
  ],
  declarations: [
    ClaimFormComponent
  ],
  exports: [
    ClaimFormComponent
  ]
})

export class ClaimsFormModule {
}
